<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <div v-show="C_isVisible" class="panel-container">
      <div class="panel-button-container">
        <a 
          class="panel-button panel-button-mic" 
          :class="{active: C_isActiveState}"
          @mousedown="eventMouseDown(P_buttonOneId, P_buttonOneMakeSingleEvent)"
          @mouseup="eventMouseRelease(P_buttonOneId, P_buttonOneMakeSingleEvent)"
          @click="eventMouseClick(P_buttonOneId, P_buttonOneMakeSingleEvent)"
        ></a>
      </div>
      <div class="panel-buttons-divider"></div>
      <div class="panel-button-container">
        <a 
          class="panel-button panel-button-decrease"
          @mousedown="eventMouseDown(P_buttonTwoId, P_buttonTwoMakeSingleEvent)"
          @mouseup="eventMouseRelease(P_buttonTwoId, P_buttonTwoMakeSingleEvent)"
          @click="eventMouseClick(P_buttonThreeId, P_buttonTwoMakeSingleEvent)"
        ></a>
      </div>
      <div class="panel-button-container">
        <a 
          class="panel-button panel-button-increase"
          @mousedown="eventMouseDown(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
          @mouseup="eventMouseRelease(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
          @click="eventMouseClick(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ['P_buttonOneId', 'P_buttonOneMakeSingleEvent', 'P_buttonTwoId','P_buttonTwoMakeSingleEvent', 'P_buttonThreeId', 'P_buttonThreeMakeSingleEvent', 'P_customCss'],
  data () {
    return {
      DV_micOFF: false
    }
  },
  mixins: [bi10GridComponent]
}
</script>

<style lang="less" scoped>
.panel-container {
  display: flex;
  border: 1px solid var(--border-color3);
  border-radius: 7px;
  padding: 6px;
  height: 100%;
  width: 100%;
  .panel-button-container {
    width: 100%;
    height: 100%;
    .panel-button {
      display: block;
      height: 100%;
      width: 100%; 
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      &.panel-button-mic {
        background-image: url(/dynamic/images/b1/NU_GUI/mic-on.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 90%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/mic-on.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
        &.active {
          background-image: url(/dynamic/images/b1/NU_GUI/mic-off-red-line.png), url(/dynamic/images/b1/NU_GUI/square-button-red.png);
          &:active {
            background-image: url(/dynamic/images/b1/NU_GUI/mic-off-red-line.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
          }
        }
      }
      &.panel-button-decrease {
        background-image: url(/dynamic/images/b1/NU_GUI/decrease.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 90%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/decrease.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
      }
      &.panel-button-increase {
        background-image: url(/dynamic/images/b1/NU_GUI/increase.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 75%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/increase.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
      }
    }
  }
  .pannel-buttons-divider {
    width: 16px;
    height: 90%;
    background: var(--background-color3);
    border-radius: 5px;
    border-left: 1px solid var(--border-color1);
    margin: 1% 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/NU_GUI/GMicPanel.vue